import Instance from '../../../../Axios';

// New Actions for the app

const GetAllFabricantes = () => async (dispatch) => {
  await Instance()
    .get(`/energias/fabricantes`)
    .then(({ data }) => {
      dispatch({ type: 'GET_ALL_FABRICANTES', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetAllFabricantes;